import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fa_fund",
  "use": "icon-fa_fund-usage",
  "viewBox": "220 260 520 480",
  "content": "<symbol viewBox=\"220 260 520 480\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-fa_fund\">\r\n  <path fill=\"none\" d=\"M240 400C240 367.909 267.909 340 300 340H660C692.091 340 720 367.909 720 400V660C720 692.091 692.091 720 660 720H300C267.909 720 240 692.091 240 660V400ZM240 400L580 280C612.091 280 640 307.909 640 340V340M600 460H720V600H600C577.909 600 560 582.091 560 500C560 477.909 577.909 460 600 460ZM660 530C676.569 530 690 516.569 690 500C690 483.431 676.569 470 660 470C643.431 470 630 483.431 630 500C630 516.569 643.431 530 660 530Z\" stroke=\"currentColor\" stroke-width=\"48\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fa_fund.svg
// module id = nFQh
// module chunks = 36